import React, { useState } from 'react';
import { Settings, Database, FolderOpen, Server, LayoutTemplate } from 'lucide-react';
import TopBar from '../../components/layout/TopBar';
import ProjectsSettings from './ProjectsSettings';
import DataSourcesSettings from './DataSourcesSettings';
import ServersSettings from './ServersSettings';
import ProjectTemplatesSettings from './ProjectTemplatesSettings';
import styles from './DataManagementPage.module.css';

export default function DataManagementPage() {
  const [activeView, setActiveView] = useState('projects');

  const menuItems = [
    {
      id: 'projects',
      label: 'Projects',
      icon: <FolderOpen size={20} />,
      component: <ProjectsSettings />
    },
    {
      id: 'data-sources',
      label: 'Data Sources',
      icon: <Database size={20} />,
      component: <DataSourcesSettings />
    },
    {
      id: 'servers',
      label: 'Servers',
      icon: <Server size={20} />,
      component: <ServersSettings />
    },
    {
      id: 'project-templates',
      label: 'Project Templates',
      icon: <LayoutTemplate size={20} />,
      component: <ProjectTemplatesSettings />
    }
  ];

  return (
    <div className={styles.dataManagementPage}>
      <TopBar isLanding={true} />
      
      {/* Background layers matching landing page exactly */}
      <div className="fixed inset-0 -z-10">
        {/* Dark mode background */}
        <div className="dark:block hidden absolute inset-0 bg-black" />
        
        {/* Light mode background */}
        <div className="light:block hidden absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-slate-100" />
        
        {/* Dark mode enhanced effects - matching landing page exactly */}
        <div className="dark:block hidden">
          {/* Futuristic background patterns - matching landing page */}
          <div className="absolute inset-0" style={{
            background: `
              radial-gradient(circle at 20% 50%, rgba(0, 255, 255, 0.03) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(0, 255, 255, 0.02) 0%, transparent 50%),
              radial-gradient(circle at 40% 80%, rgba(0, 255, 255, 0.02) 0%, transparent 50%)
            `
          }} />
        </div>

        {/* Light mode enhanced effects */}
        <div className="light:block hidden">
          {/* Light mode background patterns */}
          <div className="absolute inset-0" style={{
            background: `
              radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.08) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(59, 130, 246, 0.05) 0%, transparent 50%),
              radial-gradient(circle at 40% 80%, rgba(59, 130, 246, 0.05) 0%, transparent 50%)
            `
          }} />
        </div>

        {/* Dot grid background - matching landing page exactly */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 dark:block light:hidden" style={{
            backgroundImage: `
              radial-gradient(circle at 1px 1px, 
                rgba(0, 255, 255, 0.15) 1px, 
                transparent 0
              )
            `,
            backgroundSize: '20px 20px'
          }} />
          <div className="absolute inset-0 dark:hidden light:block" style={{
            backgroundImage: `
              radial-gradient(circle at 1px 1px, 
                rgba(59, 130, 246, 0.2) 1px, 
                transparent 0
              )
            `,
            backgroundSize: '24px 24px'
          }} />
        </div>
      </div>

      <div className={styles.content}>
        {/* Left Sidebar */}
        <div className={styles.sidebar}>
          <div className={styles.sidebarHeader}>
            <h2>Data Management</h2>
          </div>
          <nav className={styles.nav}>
            {menuItems.map((item) => (
              <button
                key={item.id}
                className={`${styles.navItem} ${activeView === item.id ? styles.active : ''}`}
                onClick={() => setActiveView(item.id)}
              >
                <span className={styles.navIcon}>{item.icon}</span>
                <span className={styles.navText}>{item.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Main Content Area */}
        <div className={styles.mainContent}>
          {menuItems.find(item => item.id === activeView)?.component}
        </div>
      </div>
    </div>
  );
}
